import { CompanyOwner } from '../types/dtos';
import { ValidationSchemaType } from 'hooks/useForm';

export const COMPANY_OWNER_INITIAL_FIELDS: CompanyOwner = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phoneNumber: '',
};

export const COMPANY_OWNER_CREATE_FIELDS_SCHEMA: ValidationSchemaType<CompanyOwner> = {
    firstName: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    lastName: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    email: {
        required: true,
        type: 'email',
    },
    password: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    phoneNumber: {
        required: true,
        maxLength: 100,
    },
};

export const COMPANY_OWNER_EDIT_FIELDS_SCHEMA: ValidationSchemaType<CompanyOwner> = {
    firstName: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    lastName: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    email: {
        required: true,
        type: 'email',
    },
    phoneNumber: {
        required: true,
        maxLength: 100,
    },
};
